import React from 'react'
import Link from 'gatsby-link'
import { BlogItems } from '../../components/blogContent'

const BlogEntry = (props) => {
	return (
		<div className="row">
			<div className="col-md-12 col-sm-12 wow fadeInUp">
				<div className="team-wrapper">
					<div className="row">
						{ props.showLeft ? 
                        <div className="col-md-2">
							<Link to={props.link}><img src={props.image} className="img-responsive"/></Link>
						</div> : null }
						<div className="col-md-10">
							<h5>{ props.date }</h5>
							<h4><Link to={props.link}>{props.title}</Link></h4>
							<p>
								{props.text}
							</p>
							<p>&nbsp;</p>
						</div>
						{ !props.showLeft ? 
                        <div className="col-md-2">
							<Link to={props.link}><img src={props.image} className="img-responsive"/></Link>
						</div> : null }
						<p>&nbsp;</p>
					</div>
				</div>
			</div>
		</div>
	);
};


const blogIndex = () => {
	return (
	<section id="blog" className="parallax-section">
		<div className="container">
		<br /><br /><br /><br /><br /><br />
		{ BlogItems.map(blog => <BlogEntry {...blog} />)}
		</div>
	</section>
	)
}
export default blogIndex



// WEBPACK FOOTER //
// ./src/pages/blog/index.js